// extracted by mini-css-extract-plugin
export default {"infoLink":"InfoLink_infoLink__C5M-w","size-small":"InfoLink_size-small__38XB-"};